import React, { useContext } from 'react';
import { useTheme } from '@emotion/react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite/no-important';
import { ThemeContext } from '../theme';
import { Loader } from '../loader';

const propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  btnType: PropTypes.oneOf([
    'primary',
    'warning',
    'success',
    'danger',
    'error'
  ]),
  isOutlineBtn: PropTypes.bool,
  isTextBtn: PropTypes.bool,
  isDisabled: PropTypes.bool,
  showLoader: PropTypes.bool,
  disableShowLoaderClick: PropTypes.bool,
  onClick: PropTypes.func
};

const defaultProps = {
  className: '',
  btnType: 'primary',
  showLoader: false,
  disableShowLoaderClick: false
};

const Button = (props) => {
  const {
    className,
    style,
    isDisabled,
    isOutlineBtn,
    isTextBtn,
    onClick,
    showLoader,
    disableShowLoaderClick
  } = props;

  const context = useContext(ThemeContext);
  // const { button } = context.theme;
  let button;
  const theme = useTheme();
  if (theme && theme.button) {
    button = theme.button;
  } else {
    button = context.theme.button;
  }

  const styles = StyleSheet.create({
    baseStyle: {
      ...button.base,
      display: 'inline-block',
      alignItems: 'flex-start',
      textAlign: 'center',
      cursor: 'pointer'
    },
    themeStyles: {
      ...(button[props.btnType].props),
      ':not(.disabled):not(.text-btn):hover': { ...(button[props.btnType].hoverProps) }
    },
    outlineStyles: { ...(button[props.btnType].outlineProps) },
    textStyles: {
      ...(button[props.btnType].textProps),
      ':not(.disabled):hover': {
        ...(button[props.btnType].textProps.hoverProps)
      }
    },
    disabledStyles: { ...(button[props.btnType].disabledProps) },
    loaderStyles: {
      display: 'flex'
    }
  });
  return (
    <div
      className={`${className}
      ${isTextBtn ? 'text-btn' : ''}
      ${isDisabled ? 'disabled' : ''}
      ${css(
        styles.baseStyle,
        styles.themeStyles,
        isOutlineBtn && styles.outlineStyles,
        isTextBtn && styles.textStyles,
        isDisabled && styles.disabledStyles,
        showLoader && styles.loaderStyles
      )}`}
      style={style}
      onClick={(e) => {
        if (!isDisabled && !disableShowLoaderClick) {
          onClick(e);
        }
      }}
    >
      <div className={css(showLoader && styles.loaderStyles)}>
        {showLoader &&
          <div style={{ height: '100%', width: '32px' }}>
            <i className='fa fa-circle-o-notch fa-spin fa-1x' />
          </div>
        }
        {props.children}
      </div>
    </div>
  );
};

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export { Button };
